import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from '@angular/core';

//System
import { TranslateService } from '@ngx-translate/core';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
//Models
import { SeoViewModel } from "./../../../../models/core/seo";
import { ActivatedRoute } from "@angular/router";
import { LanguageService } from "../../../../services/cms/language.service";
import { OrderPaymentService } from "../../../../services/cms/order-payment.service";

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  template: ''
})

export class PaymentUnicreditConfirmationComponent implements OnInit {
  data: any = {};
  constructor
    (
      private _compiler: Compiler,
      private componentHelper: ComponentHelperService,
      private _elementRef: ViewContainerRef,
      private templateService: TemplateService,
      private route: ActivatedRoute,
      private cmsComponentService: CmsComponentService,
      @Inject('isBrowser') private isBrowser: boolean,
      private seo: SeoService,
      private renderer: Renderer,
      @Inject(DOCUMENT) private document: any,
      private scriptService: ScriptService
    ) { }

  subManager = new Subscription();

  ngOnInit() {
    let id = 0;
    let paramsSub = this.route.params.subscribe(params => {
      id = params['orderid'];
    });

    this.subManager.add(paramsSub);

    let orderCheckout: any;
    let header: any;
    let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
      header = result;
      let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
        if (result1.Categories) {
          header.Categories = result1.Categories;

        }
      });
      this.subManager.add(SideMenuData);
    });
    this.subManager.add(headDataSub);
    //console.log("sono qui")
    let thankYouSub = this.templateService.getThankYouPagOnlineInfo("orderUnicreditPageTemplate", id).subscribe(result => {
      if (result.SeoInformation) {
        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
      }

      if (this.isBrowser) {
        orderCheckout = result;
        //Creating subcomponent whith the selected template to inject
        let subComponent = this.createSubComponent(orderCheckout, id, header);

        //injecting created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
      }
      else {
        let typeId = this.scriptService.getSystemPageRowId_OrderId(this.scriptService.ThankYouPagePagOnlineId, id);

        //-- Get head and body scripts
        this.scriptService.setupExternalScripts(result, this.scriptService.typeSystemPage, typeId);

        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
      }
    });

    this.subManager.add(thankYouSub);
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subManager.unsubscribe();
  }

  //Creates component to inject
  private createSubComponent(orderCheckout: any, OrderId: any, header: any) {
    @Component({
      template: orderCheckout.TemplateHtml
    })

    class ChildComponent implements OnInit {
      constructor
        (
          private routesService: RoutesService,
          private seoService: SeoService,
          private _elementRef: ViewContainerRef,
          private scriptService: ScriptService,
          @Inject('isBrowser') private isBrowser: boolean,
          private activatedRoute: ActivatedRoute,
          private languageService: LanguageService,
          private translate: TranslateService,
          private orderPaymentService: OrderPaymentService
        ) { }

      private success: boolean = false;
      private errorMessage: string = "";
      private failed: boolean = false;
      private serverError: boolean = false;
      private orderId: any = OrderId;
      private seoInfo: SeoViewModel = orderCheckout.SeoInformation;
      private encryptedOrder: any;
      private hashedOrderId: any;
      private pageIsInit: boolean = false;
      private createScript: number = 0;
      //subManager = new Subscription();
      resultPagOnline: any = orderCheckout.resultPagOnline;
      footerData: any = orderCheckout.FooterData;
      headerData: any = header;

      ngOnInit() {

        if (this.isBrowser == false) {
          return;
        }

        if (this.orderId == -1) {
          this.success = false;
          this.failed = true;
          this.serverError = false;
          this.errorMessage = this.getLabel('impossibile_pagare_ordine');
          this.createScript = -1;
        }
        else {
          //setting order as paid                                
          //let checkPaymentSub = this.orderPaymentService.CheckIsOrderPayedUnicredit(this.orderId)
          //.subscribe(result => {

          let res = this.resultPagOnline.split("|");
          if (res[0] == "1") {
            this.success = true;
            this.failed = false;
            this.serverError = false;
            this.createScript = 1;
          }
          else if (res[0] == "-1") {
            this.success = false;
            this.failed = true;
            this.serverError = false;
            this.errorMessage = res[1];
            this.createScript = -1;
          }
          else {
            this.success = false;
            this.failed = false;
            this.serverError = true;
            this.errorMessage = res[1];
            this.createScript = -1;
          }
          //})

          //this.subManager.add(checkPaymentSub);
        }
      }

      getLabel(label) {
        let message;

        this.translate.get(label, this.translate).subscribe((res: string) => {
          message = res;
        });

        return message;
      }

      ngAfterViewChecked() {
        if (!this.isBrowser || this.pageIsInit) {
          return;
        }

        //-- Set title, setup google analytics and other libraries 
        this.scriptService.setGoogleScripts(this.seoInfo);

        //hiding of loading panel after we get all data we need
        this.routesService.hidePageLoader();
        //Eventually retrieving the script to append

        this.pageIsInit = true;
      }

      ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
       //this.subManager.unsubscribe();
      }
    }
    return ChildComponent;
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/payment-unicredit-confirmation.component.ts